import {
	GrantParentCompanyTenantAccessMutation,
	RevokeParentCompanyTenantAccessMutation
} from "~/gql/mutations/parentCompany.generated";
import { MyParentCompanyQuery } from "~/gql/queries/parentCompany.generated";

export const parentCompanyEndpoints = {
	GrantParentCompanyTenantAccess: {
		invalidatesTags: ["ParentCompany"] as AddTagTypes,
		transformResponse: (res: GrantParentCompanyTenantAccessMutation) => res
	},
	MyParentCompany: {
		providesTags: ["ParentCompany"] as AddTagTypes,
		transformResponse: (res: MyParentCompanyQuery) => res
	},
	RevokeParentCompanyTenantAccess: {
		invalidatesTags: ["ParentCompany"] as AddTagTypes,
		transformResponse: (res: RevokeParentCompanyTenantAccessMutation) => res
	}
};
